import { Action } from "redux";
import { isType } from "typescript-fsa";

import * as _ from "lodash";

import * as actions from "../actions/recurrenceActions";

import { clearCurrentCalendarEvent } from "../actions/eventViewActions";

import { IRecurrenceSettingsState } from "../classes/state";

import { initialRecurrenceSettings } from "./initialState";

export default function recurrenceReducer(state: IRecurrenceSettingsState = initialRecurrenceSettings, action: Action): IRecurrenceSettingsState {

  if (isType(action, actions.clearUpdatedRecurrencePatternDescriptionAction)) {
    const newState: IRecurrenceSettingsState = {
      ...state,
      updatedRecurrenceDescription: "",
    };
    return newState;
  }

  if (isType(action, actions.clearUpdatedRecurrencePatternAction)) {
    const newState: IRecurrenceSettingsState = {
      ...state,
      updatedRecurrencePattern: null,
    };
    return newState;
  }

  if (isType(action, actions.setOpenRecurrenceModalAction)) {
    const newState: IRecurrenceSettingsState = {
      ...state,
      openRecurrencePatternModal: action.payload,
    };
    return newState;
  }

  if (isType(action, actions.loadUpdatedRecurrencePatternDescriptionSuccessAction)) {
    const newState: IRecurrenceSettingsState = {
      ...state,
      updatedRecurrenceDescription: action.payload,
    };
    return newState;
  }

  if (isType(action, actions.updateRecurrencePatternAction)) {
    const newState: IRecurrenceSettingsState = {
      ...state,
      updatedRecurrencePattern: action.payload,
    };
    return newState;
  }

  if (isType(action, clearCurrentCalendarEvent)) {
    const newState: IRecurrenceSettingsState = {
      ...state,
      updatedRecurrenceDescription: "",
      updatedRecurrencePattern: null,
    };
    return newState;
  }

  return state;
};
